import { Component, Input } from '@angular/core';
import { ClientHistoryNotes } from 'src/app/shared/api-models/log';
import { SortConfig } from 'src/app/shared/view-models/sort-config';
import { HistoryNotesService } from '../history-notes.service';

@Component({
	selector: 'crm-history-notes-table',
	templateUrl: './history-notes-table.component.html'
})
export class HistoryNotesTableComponent {
	@Input() getHistoryNotes: (serviceLocationId: number, refreshData: boolean) => void;
	public sortConfig: SortConfig = {
		column: 'LogDate',
		direction: 'desc'
	};
	public showEditModal: boolean = false;

	constructor(public historyNotesService: HistoryNotesService) {}

	public onSortClick(newConfig: SortConfig) {
		this.sortConfig = newConfig;
		this.historyNotesService.viewState.orderByCol = this.sortConfig.column;
		if (this.sortConfig.direction === 'asc') {
			this.sortConfig.direction = 'desc';
			this.historyNotesService.viewState.orderDesc = true;
		} else {
			this.sortConfig.direction = 'asc';
			this.historyNotesService.viewState.orderDesc = false;
		}
		this.getHistoryNotes(this.historyNotesService.viewState.locationId, true);
	}

	public getSortIconClass(column: string): string {
		if (this.sortConfig.column !== column) {
			return 'fas fa-sort';
		}
		return this.sortConfig.direction === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down';
	}

	public onEditClick(historyNote: ClientHistoryNotes): void {
		this.historyNotesService.selectedHistoryNote = historyNote;
		this.showEditModal = true;
	}

	public onDeleteClick(historyNote: ClientHistoryNotes): void {
		this.historyNotesService.deleteHistoryNote(historyNote);
	}

	public onEditModalExit(): void {
		this.showEditModal = false;
	}

	public onPageChange(page?: number): void {
		if (page) {
			this.historyNotesService.viewState.pageNumber = page;
		}
		this.historyNotesService.getHistoryNotes(this.historyNotesService.viewState.locationId, true).subscribe((historyNotes: ClientHistoryNotes[]) => {
			this.historyNotesService.historyNotes = historyNotes;
			window.scrollTo(0, 500);
		});
	}
}
